<template>
    <div>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-66">
                <form ref="intervention_group_add" @submit.prevent="addInterventionGroup">
                    <md-card>
                        <md-card-header class="md-card-header-icon md-card-header-blue">
                            <div class="card-icon">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
                            </div>
                            <h4 class="title">Modification du plan d'intervention</h4>
                        </md-card-header>
                        <intervention-group-form
	                        edit
	                        :interventionGroup="newInterventionGroup"
	                        :errors="errors"
	                        :filteredInterventionTypes="interventionTypes">
                        </intervention-group-form>
                        <md-card-actions md-alignment="left">
	                        <div class="flex items-center justify-end space-x-4 h-full">
		                        <md-button class="md-icon-button md-raised md-success" :disabled="loading" type="submit">
			                        <font-awesome-icon class="md-icon" :icon="['fa', loading ? 'sync-alt' : 'plus-circle']" :class="{ 'animate-spin': loading }"></font-awesome-icon>
			                        <span class="leading-none font-medium ml-2"> Ajouter</span>
		                        </md-button>
		                        <md-button class="md-icon-button md-raised md-warning" @click="goBack">
			                        <font-awesome-icon class="md-icon" :icon="['fa', 'arrow-left']"></font-awesome-icon>
			                        <span class="leading-none font-medium ml-2"> Retour</span>
		                        </md-button>
	                        </div>
                        </md-card-actions>
                    </md-card>
                </form>
            </div>
        </div>
		<intervention-plan-edit-group-card
			v-for="planningInterventionGroup in interventionPlan.planning_intervention_groups"
			:key="planningInterventionGroup.id"
			:planningInterventionGroup="planningInterventionGroup"
            :interventionTypes="interventionTypes"
            :deviceGroups="deviceGroups"
			@deactivate-group="removeGroupFromInterventionPlan"
			@duplicate-group="pushGroupsInInterventionPlan">
		</intervention-plan-edit-group-card>
	</div>
</template>

<script>
import InterventionGroupForm from "@/pages/Contracts/InterventionPlan/components/InterventionGroupForm";
import InterventionPlanEditGroupCard from "@/pages/Contracts/InterventionPlan/components/InterventionPlanEditGroupCard";

export default {
    name: "InterventionPlanEdit",
	components: {
        InterventionGroupForm, InterventionPlanEditGroupCard
	},
    data() {
        return {
            interventionPlan: {
                planning_intervention_groups: []
            },
            interventionTypes: [],
            deviceGroups: [],
            newInterventionGroup: {
                types: [],
                months: [],
                duration: null
            },
            errors: [],
	        loading: false
        }
    },
    methods: {
        async getInterventionPlanDetails() {
            const { data } = await this.$store.dispatch('interventionPlans/getInterventionPlanDetails', {
                planningInterventionId: this.$route.params.planningInterventionId
            })
            this.interventionPlan = data
        },
        async getInterventionTypes() {
            const { data } = await this.$store.dispatch('interventionTypes/getInterventionTypes')
            let usedInterventionTypes = this.interventionPlan.planning_intervention_groups.map(group => {
                return group.intervention_type_id
            })
            this.interventionTypes = data.filter(interventionType => {
                return interventionType ? !usedInterventionTypes.find(type => type === interventionType.id) : null
            })
        },
        async getContractDeviceGroups() {
            const { data } = await this.$store.dispatch('contracts/getContractDeviceGroups', {
                contractId: this.$route.params.contractId
            })
            this.deviceGroups = data
        },
        async addInterventionGroup() {
            this.errors = []
            let hours = parseInt(this.$moment(this.newInterventionGroup.duration).format('HH'))
            let minutes = parseInt(this.$moment(this.newInterventionGroup.duration).format('mm'))
	        this.loading = true
            try {
                const { data } = await this.$store.dispatch('interventionPlans/addInterventionGroup', {
                    planning_intervention_id: this.interventionPlan.id,
                    intervention_types: this.newInterventionGroup.types.map(type => type.id),
                    months: this.newInterventionGroup.months.map(month => month.value),
                    duration: ((hours * 60) + minutes)
                })

                await this.getInterventionTypes()
	            this.pushGroupsInInterventionPlan(data)
                this.newInterventionGroup = { types: [], months: [], duration: null }

	            await this.$store.dispatch('alerts/success', 'Type d\'intervention ajouté au plan d\'intervention')
            } catch (e) {
                this.errors = e.response.data.errors
            } finally {
	            this.loading = false
            }
        },
	    pushGroupsInInterventionPlan(groups) {
			this.interventionPlan.planning_intervention_groups.push(...groups)
		    this.interventionPlan.planning_intervention_groups.sort((a, b) => {
			    return (a.intervention_type.name > b.intervention_type.name) ? 1 : ((a.intervention_type.name < b.intervention_type.name) ? -1 : 0)
		    })
	    },
	    removeGroupFromInterventionPlan(group) {
		    this.interventionPlan.planning_intervention_groups = this.interventionPlan.planning_intervention_groups.filter(g => g.id !== group.id)
		    this.getInterventionTypes()
	    },
        goBack() {
            this.$router.back()
        }
    },
    mounted() {
        this.getInterventionPlanDetails()
        this.getInterventionTypes()
        this.getContractDeviceGroups()
    }
}
</script>

<style scoped lang="scss">
.md-layout-item.pl-0:first-child {
    padding-left: 0 !important;
}
</style>
